/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum VideoSourceType {
    /**
     * The source to get is the original device
     */ 
    Default = 0,
    /**
     * The source to get is a restreamer for the device
     */ 
    RtspRestreamer = 1,
}
